import React from 'react';
import DragAndDrop from '../DragAndDrop';

const FileUploader = ({ onFileSelect, onFileDrop, onUpload }) => {


    return (
        <div className='w-1/2'>
            <DragAndDrop onFileSelect={onFileSelect} onFileDrop={onFileDrop} />
            <button
                className={
                    "rounded font-medium h-10 text-white w-full bg-header_bg my-3 focus:outline-none text-sm"
                }
                aria-label="Submit"
                onClick={onUpload}
            >
                SUBMIT
            </button>
        </div>
    );
};

export default FileUploader;